module.exports = __webpack_public_path__ + "img/lacy-foundries.2a4871c0.jpg";